import { render, staticRenderFns } from "./custom-item-details.vue?vue&type=template&id=060d737b&scoped=true"
import script from "./custom-item-details.vue?vue&type=script&lang=js"
export * from "./custom-item-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d737b",
  null
  
)

export default component.exports